import { generateReactHelpers } from '@uploadthing/react';
import { getUploadAuthHeaders } from '../authHeaders';

export const { useUploadThing, uploadFiles } = generateReactHelpers({
	url: `${process.env.REACT_APP_API_URL}/api/uploadthing`,
});

export const buildUploadHeaders = (extraHeaders = {}) =>
	getUploadAuthHeaders(
		typeof extraHeaders === 'function' ? extraHeaders() : extraHeaders,
	);
